<template>
  <div id="vermieterprogramm-form-app" class="rental__registerform">
    <div class="loading-overlay" v-if="loading">
      <div class="loading-ring"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
    <transition name="component-fade" mode="out-in">
    <Component
      :is="step"
      :privacyPage="privacyPage"
      :errorMessage="errorMessage"
      @updateStep="step = $event"
      @handleRequest="handleRequest()"
    :registerform="registerform"></Component>
    </transition>
  </div>
</template>

<script>
import StepOne from './components/Steps/StepOne.vue'
import StepTwo from './components/Steps/StepTwo.vue'
import StepThree from './components/Steps/StepThree.vue'
import Error from './components/Steps/Error.vue'
import axios from 'axios'

export default {
  name: 'App',
  data () {
    return {
      loading: false,
      step: 'StepOne',
      license: 2,
      privacyPage: window.tx_rental.privacyPage,
      successPage: window.tx_rental.successPage,
      apiBase: window.tx_rental.typo3ApiBase,
      errorMessage: [],
      registerform: {
        state: '',
        rentalSinceYear: '',
        plannedStartYear: '',
        vehicleCount: 1,
        vehicleCountPlanned: 1,
        vehicleCountExtendingPlanned: 'non',
        vehicleCountPlannedThreeYears: '',
        marketing: {
          regional: 0,
          ebay: 0,
          rentalPortals: ''
        },
        contact: {
          salutation: '',
          company: '',
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
          zip: '',
          city: '',
          availability: '',
          privacy: false
        }
      }
    }
  },
  components: {
    StepOne,
    StepTwo,
    StepThree,
    Error
  },
  methods: {
    handleRequest: function () {
      let apiBase = this.apiBase
      let url = new URL(apiBase + 'step-one')

      url.searchParams.set('state', this.registerform.state)
      url.searchParams.set('license', this.license)
      url.searchParams.set('company', this.registerform.contact.company)
      url.searchParams.set('contact-firstname', this.registerform.contact.firstname)
      url.searchParams.set('contact-lastname', this.registerform.contact.lastname)
      url.searchParams.set('email', this.registerform.contact.email)
      url.searchParams.set('phone', this.registerform.contact.phone)
      url.searchParams.set('zip', this.registerform.contact.zip)
      url.searchParams.set('city', this.registerform.contact.city)
      url.searchParams.set('privacy', this.registerform.contact.privacy)
      url.searchParams.set('salutation', this.registerform.contact.salutation)
      url.searchParams.set('availability', this.registerform.contact.availability)
      if (this.registerform.state === 0) {
        url.searchParams.set('vehicles-count-planned', this.registerform.vehicleCountPlanned)
      } else if (this.registerform.state === 1) {
        url.searchParams.set('vehicles-count-planned', this.registerform.vehicleCountPlanned)
        url.searchParams.set('planned-start-year', this.$moment(this.registerform.plannedStartYear).format('YYYY'))
        url.searchParams.set('vehicles-count-planned-three-years', this.registerform.vehicleCountPlannedThreeYears)
      } else if (this.registerform.state === 2) {
        url.searchParams.set('since-year', this.$moment(this.registerform.rentalSinceYear).format('YYYY'))
        url.searchParams.set('vehicles-count', this.registerform.vehicleCount)
        url.searchParams.set('vehicles-count-extending-planned', this.registerform.vehicleCountExtendingPlanned)
        url.searchParams.set('vehicles-count-planned-three-years', this.registerform.vehicleCountPlannedThreeYears)
        url.searchParams.set('marketing-ebay', this.registerform.marketing.ebay)
        url.searchParams.set('marketing-regional', this.registerform.marketing.regional)
        url.searchParams.set('marketing-rental-portals-other', this.registerform.marketing.rentalPortals)
      }
      let self = this
      this.loading = true
      axios.post(url).then(response => {
        window.location.href = this.successPage
        self.loading = false
        console.log(response)
      }).catch(e => {
        self.step = 'Error'
        self.loading = false
        self.errorMessage = e.response.data.errors
      })
    }
  }
}
</script>
